module.exports = __webpack_public_path__ + "img/40.b21c0868.jpg";